module.exports = __webpack_public_path__ + "img/slack.8690c1e3.svg";